import Rollbar from "rollbar";

const rollbarConfig = {
  enabled: true,
  accessToken: process.env.SERVER_ROLLBAR_TOKEN || process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NEXT_PUBLIC_ROLLBAR_ENV,
  client: {
    javascript: {
      source_map_enabled: true,
      code_version: process.env.NEXT_PUBLIC_VERSION,
      guess_uncaught_frames: true
    }
  },
  server: {
    branch: process.env.NODE_ENV == 'production' ? "main" : "dev"
  },
  code_version: process.env.NEXT_PUBLIC_VERSION
}

class LoggingService {

  constructor() {
    if (LoggingService.instance == null) {
      LoggingService.instance = this
      this.rollbar = new Rollbar(rollbarConfig);
    }
    return LoggingService.instance;
  }

  error(message, error, context) {
    this.rollbar.error(error || message, context)
    if (process.env.NODE_ENV == "development") {
      if (message) console.log(message)
      if (error) console.log(error)
      if (context) console.log(context)
    }
  }

}

const loggingService = new LoggingService();
Object.freeze(loggingService);
export default loggingService;